module.exports = __webpack_public_path__ + "img/9.bbef1d1.png";